import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchUserTagData } from "../../actions/setUserTagData";
import type { AppDispatch } from "@Reducers/index";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

/**
 * Loads one account into the shared `userTagData` store and renders nothing.
 *
 * It exists as a component so that "there is an account id worth fetching" is expressed by whether
 * it is MOUNTED rather than by a branch inside an effect: both avatars take a loose `string | number`
 * id from ~80 call sites (grid RowIds included), so the id has to be validated before it can be sent
 * as an account id, and the validation happens in the parent's render instead.
 *
 * `fetchUserTagData` de-duplicates against the store (`isLoading`/`isLoaded`), so several of these
 * mounted for the same account issue a single request.
 */
function UserTagDataFetcher({ accountId }: { readonly accountId: ObjectIdString }) {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Fire-and-forget: the avatar/tag renders off `userTagData` once it lands.
    void dispatch(fetchUserTagData(accountId));
  }, [accountId, dispatch]);

  return null;
}

export default UserTagDataFetcher;
